var render, staticRenderFns
import script from "./LotView.vue?vue&type=script&lang=js&"
export * from "./LotView.vue?vue&type=script&lang=js&"
import style0 from "./LotView.vue?vue&type=style&index=0&id=2f653d6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f653d6e",
  null
  
)

export default component.exports